(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    class ShopTheLookTriggerPosition {
    constructor(element) {
      this.element = element;
      this.triggerButton = element.querySelector('.shop-the-look__trigger');
      this.mediaContainer = element.closest('.product-information__media') || document.querySelector('.product-information__media');
      this.galleryGrid = null;
      this.ticking = false;
      this.abortController = new AbortController();

      if (!this.mediaContainer || !this.triggerButton || !this.#resolveGalleryGrid()) return;

      this.#update();
      this.element.classList.add('shop-the-look--is-active');
      window.addEventListener('resize', this.#handleResize, { signal: this.abortController.signal });
      window.addEventListener('scroll', this.#handleScroll, { passive: true, signal: this.abortController.signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.#update());
        this.resizeObserver.observe(this.mediaContainer);
        this.resizeObserver.observe(this.triggerButton);
        this.resizeObserver.observe(this.galleryGrid);
      }
    }

    #resolveGalleryGrid() {
      const liveGrid = this.element.closest('media-gallery')?.querySelector('.media-gallery__grid');

      if (!liveGrid) {
        this.galleryGrid = null;
        return null;
      }

      if (liveGrid !== this.galleryGrid) {
        this.galleryGrid = liveGrid;

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          if (this.mediaContainer) this.resizeObserver.observe(this.mediaContainer);
          if (this.triggerButton) this.resizeObserver.observe(this.triggerButton);
          this.resizeObserver.observe(this.galleryGrid);
        }
      }

      return this.galleryGrid;
    }

    destroy() {
      this.abortController.abort();
      this.resizeObserver?.disconnect();
    }

    #handleResize = () => {
      this.#update();
    };

    #handleScroll = () => {
      if (this.ticking) return;

      this.ticking = true;
      requestAnimationFrame(() => {
        this.#update();
        this.ticking = false;
      });
    };

    #update() {
      this.#updatePosition();
      this.#updateVisibility();
    }

    #updatePosition() {
      const mediaWidth = this.mediaContainer.getBoundingClientRect().width;
      const triggerWidth = this.triggerButton.getBoundingClientRect().width;
      if (!mediaWidth || !triggerWidth) return;

      const inlineStart = Math.max(0, mediaWidth);
      this.element.style.setProperty('--shop-the-look-trigger-inline-start', `${inlineStart}px`);
      this.element.style.setProperty('--shop-the-look-trigger-width', `${triggerWidth}px`);
    }

    #updateVisibility() {
      if (!this.#resolveGalleryGrid()) return;

      const galleryRect = this.galleryGrid.getBoundingClientRect();
      const triggerOffset = Number.parseFloat(getComputedStyle(this.element).getPropertyValue('--shop-the-look-trigger-offset')) || 32;
      const triggerLine = window.innerHeight - triggerOffset;
      const isWithinTop = galleryRect.top < window.innerHeight;
      const isBeforeEnd = galleryRect.bottom > triggerLine;
      const shouldShow = isWithinTop && isBeforeEnd;

      this.element.classList.toggle('shop-the-look--is-active', shouldShow);
    }
  }

  class DstrezzedThumbnailVisibility {
    constructor(element) {
      this.element = element;
      this.galleryGrid = null;
      this.ticking = false;
      this.abortController = new AbortController();

      if (!this.#resolveGalleryGrid()) return;

      this.#updateMaxHeight();
      this.#updateVisibility();
      window.addEventListener('resize', this.#handleResize, { signal: this.abortController.signal });
      window.addEventListener('scroll', this.#handleScroll, { passive: true, signal: this.abortController.signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.#updateVisibility());
        this.resizeObserver.observe(this.galleryGrid);
      }
    }

    destroy() {
      this.abortController.abort();
      this.resizeObserver?.disconnect();
    }

    /**
     * Variant morph can replace `.media-gallery__grid` (e.g. when Shop The Look
     * appears/disappears per color). Keep a live reference so visibility checks
     * do not use a detached node's zero rect and permanently hide thumbnails.
     */
    #resolveGalleryGrid() {
      const liveGrid = this.element.closest('media-gallery')?.querySelector('.media-gallery__grid');

      if (!liveGrid) {
        this.galleryGrid = null;
        return null;
      }

      if (liveGrid !== this.galleryGrid) {
        this.galleryGrid = liveGrid;

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.galleryGrid);
        }
      }

      return this.galleryGrid;
    }

    #updateMaxHeight() {
      const firstItem = this.element.querySelector('.media-gallery__dstrezzed-thumbnail-item');
      if (!firstItem) return;
      const itemHeight = firstItem.getBoundingClientRect().height;
      const gap = Number.parseFloat(getComputedStyle(this.element.querySelector('.media-gallery__dstrezzed-thumbnails-list')).gap) || 8;
      const maxHeight = 6.3 * itemHeight + 6 * gap;
      this.element.style.maxBlockSize = `${maxHeight}px`;
    }

    #handleResize = () => {
      this.#updateMaxHeight();
      this.#updateVisibility();
    };

    #handleScroll = () => {
      if (this.ticking) return;

      this.ticking = true;
      requestAnimationFrame(() => {
        this.#updateVisibility();
        this.ticking = false;
      });
    };

    #updateVisibility() {
      if (!this.#resolveGalleryGrid()) return;

      const galleryRect = this.galleryGrid.getBoundingClientRect();
      const triggerOffset = Number.parseFloat(getComputedStyle(this.element).getPropertyValue('--media-gallery-dstrezzed-thumbnail-trigger-offset')) || 32;
      const triggerLine = window.innerHeight - triggerOffset;
      const isWithinTop = galleryRect.top < window.innerHeight;
      const isBeforeEnd = galleryRect.bottom > triggerLine;
      const shouldShow = isWithinTop && isBeforeEnd;

      this.element.classList.toggle('media-gallery__dstrezzed-thumbnails--is-active', shouldShow);
    }
  }

  class ShopTheLookVariantPicker {

    constructor(element) {
      this.element = element;
      this.form = /** @type {HTMLFormElement | null} */ (element.querySelector('.shop-the-look__item-form'));
      this.optionInputs = Array.from(element.querySelectorAll('[data-shop-look-option-index]')).filter(
        (input) => input instanceof HTMLSelectElement
      );
      this.variantInput = element.querySelector('[data-shop-look-variant-id]');
      this.submitButton = element.querySelector('[data-shop-look-submit]');
      this.priceElement = element.querySelector('[data-shop-look-price]');
      this.comparePriceElement = element.querySelector('[data-shop-look-compare-price]');
      this.variantsScript = element.querySelector('[data-shop-look-variants]');
      this.packshotsScript = element.querySelector('[data-shop-look-packshots]');
      this.mediaImage = element.querySelector('.shop-the-look__item-image');
      this.colorOptionIndex = Number.parseInt(element.dataset.shopLookColorOptionIndex || '', 10);
      this.variants = this.#parseVariants();
      this.packshots = this.#parsePackshots();

      if (!this.form || !this.variantInput || !this.submitButton) {
        return;
      }

      this.form.addEventListener('submit', this.#handleSubmit);

      if (this.optionInputs.length > 0 && this.variants.length > 0) {
        this.optionInputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.#syncVariant(true);
            this.#resizeSelect(input);
          });
        });

        this.#syncVariant();
        this.optionInputs.forEach((input) => this.#resizeSelect(input));
      }
    }

    #parseVariants() {
      if (!this.variantsScript) return [];

      try {
        const parsed = JSON.parse(this.variantsScript.textContent || '[]');
        return Array.isArray(parsed) ? parsed.filter((v) => !v.isHiddenSize && !v.isHiddenColor) : [];
      } catch (error) {
        return [];
      }
    }

    #parsePackshots() {
      if (!this.packshotsScript) return [];

      try {
        const parsed = JSON.parse(this.packshotsScript.textContent || '[]');
        return Array.isArray(parsed)
          ? parsed.filter(
              (entry) =>
                entry &&
                (entry.kind === 'flatshot' || entry.kind === '9' || entry.kind === '50') &&
                entry.src
            )
          : [];
      } catch (error) {
        return [];
      }
    }

    #resolvePackshotForColor(colorLabel) {
      const needle = String(colorLabel || '')
        .trim()
        .toLowerCase();
      const colorMatched = { flatshot: null, '9': null, '50': null };
      const anyMatched = { flatshot: null, '9': null, '50': null };

      for (const entry of this.packshots) {
        if (!entry?.src || (entry.kind !== 'flatshot' && entry.kind !== '9' && entry.kind !== '50')) continue;

        if (!anyMatched[entry.kind]) {
          anyMatched[entry.kind] = entry;
        }

        if (!needle) continue;
        const alt = String(entry.alt || '').toLowerCase();
        if (alt.includes(needle) && !colorMatched[entry.kind]) {
          colorMatched[entry.kind] = entry;
        }
      }

      return (
        colorMatched.flatshot ||
        colorMatched['9'] ||
        colorMatched['50'] ||
        anyMatched.flatshot ||
        anyMatched['9'] ||
        anyMatched['50'] ||
        null
      );
    }

    #selectedColorLabel() {
      if (!Number.isInteger(this.colorOptionIndex) || this.colorOptionIndex < 0) return '';
      const colorInput = this.optionInputs[this.colorOptionIndex];
      return colorInput instanceof HTMLSelectElement ? colorInput.value : '';
    }

    #resizeSelect(select) {
      const text = select.options[select.selectedIndex]?.text ?? '';
      const ruler = document.createElement('span');
      const computed = getComputedStyle(select);
      ruler.style.cssText = `position:fixed;visibility:hidden;white-space:nowrap;pointer-events:none;font:${computed.font};letter-spacing:${computed.letterSpacing};`;
      ruler.textContent = text;
      document.body.appendChild(ruler);
      select.style.width = `${ruler.offsetWidth + 24}px`;
      ruler.remove();
    }

    #syncVariant(updateImage = false) {
      const selectedOptions = this.optionInputs.map((input) => input.value);
      let matchedVariant = this.variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;
        return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
      });

      if (!matchedVariant) {
        matchedVariant = this.variants.find((variant) => variant.available) || this.variants[0];
      }

      if (!matchedVariant) return;

      this.variantInput.value = matchedVariant.id;
      this.variantInput.disabled = !matchedVariant.available;
      this.submitButton.disabled = !matchedVariant.available;
      const addLabel = this.element.dataset.shopLookAddLabel || '';
      const soldOutLabel = this.element.dataset.shopLookSoldOutLabel || '';
      const submitLabel = this.submitButton.querySelector('span') || this.submitButton;
      submitLabel.textContent = matchedVariant.available ? addLabel : soldOutLabel;

      if (this.priceElement && typeof matchedVariant.price === 'number') {
        this.priceElement.textContent = this.#formatMoney(matchedVariant.price);
      }

      if (this.comparePriceElement && typeof matchedVariant.compare_at_price === 'number' && matchedVariant.compare_at_price > matchedVariant.price) {
        this.comparePriceElement.textContent = this.#formatMoney(matchedVariant.compare_at_price);
        this.comparePriceElement.hidden = false;
      } else if (this.comparePriceElement) {
        this.comparePriceElement.hidden = true;
      }

      if (updateImage) {
        this.#updateMediaImage(matchedVariant);
      }
    }

    #updateMediaImage(variant) {
      if (!this.mediaImage || !variant) return;

      const resolved = this.#resolvePackshotForColor(this.#selectedColorLabel());
      const src = resolved?.src || variant.packshot_image || variant.featured_image;
      if (!src) return;

      this.mediaImage.src = src;
      this.mediaImage.removeAttribute('srcset');

      const alt = resolved?.alt || variant.packshot_image_alt || variant.featured_image_alt;
      if (alt) {
        this.mediaImage.alt = alt;
      }
    }

    #formatMoney(value) {
      const moneyFormat = this.element.dataset.shopLookMoneyFormat || '{{amount}}';
      const amount = Number(value) / 100;
      return moneyFormat.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
        const useComma = placeholder.includes('comma') || placeholder.includes('space');
        const decimalSep = useComma ? ',' : '.';
        const thousandsSep = useComma ? '.' : ',';
        const precision = placeholder.includes('no_decimals') ? 0 : 2;
        const formatted = amount.toFixed(precision);
        const [int, dec] = formatted.split('.');
        const intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
        return precision > 0 ? `${intFormatted}${decimalSep}${dec}` : intFormatted;
      });
    }

    #handleSubmit = async (event) => {
      event.preventDefault();

      if (!this.form || !(this.variantInput instanceof HTMLInputElement) || !(this.submitButton instanceof HTMLButtonElement)) {
        return;
      }

      if (this.submitButton.disabled || this.variantInput.disabled) return;

      const formData = new FormData(this.form);
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];

      for (const cartItemsComponent of cartItemsComponents) {
        if (!(cartItemsComponent instanceof HTMLElement) || !cartItemsComponent.dataset.sectionId) continue;
        sectionIds.push(cartItemsComponent.dataset.sectionId);
      }

      if (sectionIds.length > 0) {
        formData.append('sections', sectionIds.join(','));
      }

      const quantity = Number(formData.get('quantity')) || 1;
      const endpoint = window.Theme?.routes?.cart_add_url || '/cart/add.js';

      this.submitButton.disabled = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          this.submitButton.disabled = this.variantInput.disabled;
          return;
        }

        const productId = this.element.dataset.shopLookProductId || '';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: `shop-the-look-${productId}`,
              data: {
                source: 'product-form-component',
                itemCount: quantity,
                productId,
                sections: data.sections || {},
              },
            },
          })
        );
        document.querySelector('cart-drawer-component')?.open();
      } catch (error) {
        // no-op: keep UX stable and avoid redirect behavior on failure
      } finally {
        this.submitButton.disabled = this.variantInput.disabled;
      }
    };
  }

  /** @type {Map<Element, ShopTheLookTriggerPosition>} */
  const shopTheLookPositionInstances = window.__shopTheLookPositionInstances || new Map();
  /** @type {Map<Element, DstrezzedThumbnailVisibility>} */
  const dstrezzedThumbnailInstances = window.__dstrezzedThumbnailInstances || new Map();
  const mobileDstrezzedZoomQuery = window.matchMedia('(max-width: 749px)');

  window.__shopTheLookPositionInstances = shopTheLookPositionInstances;
  window.__dstrezzedThumbnailInstances = dstrezzedThumbnailInstances;

  const parseAspectRatioValue = (aspectRatioValue) => {
    if (typeof aspectRatioValue !== 'string') return null;

    const ratioMatch = aspectRatioValue.match(/([\d.]+)\s*\/\s*([\d.]+)/);
    if (ratioMatch) {
      const widthRatio = Number.parseFloat(ratioMatch[1]);
      const heightRatio = Number.parseFloat(ratioMatch[2]);
      if (Number.isFinite(widthRatio) && Number.isFinite(heightRatio) && widthRatio > 0 && heightRatio > 0) {
        return widthRatio / heightRatio;
      }
    }

    const decimalRatio = Number.parseFloat(aspectRatioValue);
    if (Number.isFinite(decimalRatio) && decimalRatio > 0) {
      return decimalRatio;
    }

    return null;
  };

  const syncDstrezzedMobileZoomHeight = () => {
    if (!mobileDstrezzedZoomQuery.matches) return;

    const galleries = document.querySelectorAll('.media-gallery--zoom-animation-dstrezzed > slideshow-component');
    for (const gallery of galleries) {
      const galleryWidth = gallery.getBoundingClientRect().width;
      if (!galleryWidth) continue;

      const galleryStyles = getComputedStyle(gallery);
      const aspectRatio = parseAspectRatioValue(galleryStyles.aspectRatio);
      if (!aspectRatio) continue;

      const calculatedHeight = Math.round(galleryWidth / aspectRatio);
      gallery.style.setProperty('--slide-min-height-custom', `${calculatedHeight}px`);
    }
  };
  let isDstrezzedMobileZoomHeightSyncScheduled = false;

  const scheduleDstrezzedMobileZoomHeightSync = () => {
    if (isDstrezzedMobileZoomHeightSyncScheduled) return;
    isDstrezzedMobileZoomHeightSyncScheduled = true;

    requestAnimationFrame(() => {
      isDstrezzedMobileZoomHeightSyncScheduled = false;
      syncDstrezzedMobileZoomHeight();
    });
  };

  const cleanupDetachedInstances = () => {
    for (const [element, instance] of shopTheLookPositionInstances) {
      if (element.isConnected) continue;
      instance.destroy();
      shopTheLookPositionInstances.delete(element);
    }

    for (const [element, instance] of dstrezzedThumbnailInstances) {
      if (element.isConnected) continue;
      instance.destroy();
      dstrezzedThumbnailInstances.delete(element);
    }
  };

  const initMobileSlideProgress = () => {
    for (const bar of document.querySelectorAll('.dstr-slide-progress:not([data-progress-ready])')) {
      const slideshow = bar.closest('slideshow-component');
      if (!slideshow) continue;
      bar.dataset.progressReady = '';
      const total = parseInt(bar.dataset.total || '1', 10);
      slideshow.addEventListener('slideshow:select', (e) => {
        bar.style.width = `${((e.detail?.index ?? 0) + 1) / total * 100}%`;
      });
    }
  };

  const initDstrezzedGalleryEnhancements = () => {
    cleanupDetachedInstances();
    initMobileSlideProgress();

    const shopTheLookItems = document.querySelectorAll('[data-shop-look-item]');
    const shopTheLookComponents = document.querySelectorAll('.shop-the-look');
    const dstrezzedThumbnails = document.querySelectorAll('[data-dstrezzed-thumbnails]');

    for (const item of shopTheLookItems) {
      if (item.hasAttribute('data-shop-look-ready')) continue;
      item.setAttribute('data-shop-look-ready', '');
      new ShopTheLookVariantPicker(item);
    }

    for (const component of shopTheLookComponents) {
      const existing = shopTheLookPositionInstances.get(component);
      if (existing) {
        existing.destroy();
        shopTheLookPositionInstances.delete(component);
      }
      const instance = new ShopTheLookTriggerPosition(component);
      shopTheLookPositionInstances.set(component, instance);
    }

    for (const thumbnails of dstrezzedThumbnails) {
      const existing = dstrezzedThumbnailInstances.get(thumbnails);
      if (existing) {
        existing.destroy();
        dstrezzedThumbnailInstances.delete(thumbnails);
      }
      const instance = new DstrezzedThumbnailVisibility(thumbnails);
      dstrezzedThumbnailInstances.set(thumbnails, instance);
    }

    scheduleDstrezzedMobileZoomHeightSync();
  };

  if (!window.__dstrezzedGalleryEnhancementsReady) {
    window.__dstrezzedGalleryEnhancementsReady = true;

    document.addEventListener('variant:update', () => {
      requestAnimationFrame(() => {
        initDstrezzedGalleryEnhancements();
      });
    });

    document.addEventListener('shopify:section:load', () => {
      initDstrezzedGalleryEnhancements();
    });

    window.addEventListener('resize', scheduleDstrezzedMobileZoomHeightSync, { passive: true });
    mobileDstrezzedZoomQuery.addEventListener('change', scheduleDstrezzedMobileZoomHeightSync);
  }

  initDstrezzedGalleryEnhancements();
  } catch(e) { console.error(e); }
})();

})();
